import React from "react";
import { ClickEventType, ParlorDetailProps } from "../../../types";
import { Box, Stack } from "@mui/material";
import {
  ColorSystemProps,
  FUNERAL_SIDO,
  FUNERAL_SIGUNGU,
  GOI_WEB_URL,
  LEGAL_TEXTS,
  광역sidoCode,
} from "../../../constants";
import { B_2TypeCTA } from "./CTA";
import { BTypePriceSummary } from "./PriceSummary";
import { CTypeFacility } from "./Facility";
import { colors } from "../../../styles";
import { Spacing } from "../../common";
import { FixedBottomButton } from "../../Buttons";

export function FTypeCompareParlor({
  firstParlor,
  secondParlor,
  mainColor,
  event,
}: {
  firstParlor: ParlorDetailProps;
  secondParlor: ParlorDetailProps;
  mainColor: ColorSystemProps;
  event?: ClickEventType;
}) {
  const is광역 = 광역sidoCode.includes(Number(firstParlor.sido));

  const sidoSigungu = is광역
    ? FUNERAL_SIDO.get(Number(firstParlor.sido))
    : FUNERAL_SIGUNGU.get(Number(firstParlor.sido))?.get(
        Number(firstParlor.sigungu)
      );

  return (
    <>
      <Stack
        padding="20px"
        position="relative"
        justifyContent="center"
        gap="10px"
      >
        <Stack
          gap="6px"
          padding="40px 20px 20px"
          style={{
            background: "white",
            boxShadow: "0px 0px 12px 0px rgba(0, 0, 0, 0.12)",
          }}
        >
          <Stack padding="0 20px">
            <Box>
              <h2 className="subtitle_21_b">
                {firstParlor.companyname}
                <span className="body_14_m">과</span>
              </h2>
            </Box>
            <Box>
              <h2 className="subtitle_21_b">
                {secondParlor.companyname}
                <span className="body_14_m">비용 및 장례식장 유형</span>
              </h2>
            </Box>
            <Box className="body_14_m">
              을 비교하고 관련 정보를 알려드립니다.
            </Box>
          </Stack>
          <Box
            width="100%"
            height="1px"
            style={{ background: colors.gray300 }}
            margin="10px 0"
          />
          <Stack className="white" width="100%" justifyContent="flex-start">
            <Box className="caption_11_r gray700" whiteSpace="pre-line">
              {LEGAL_TEXTS.FIFTY_GUESTS}
            </Box>
          </Stack>
        </Stack>

        <Stack
          padding="20px 12px 0"
          className="body_16_m gray900"
          style={{
            background: "white",
            boxShadow: "0px 0px 12px 0px rgba(0, 0, 0, 0.12)",
          }}
        >
          <BTypePriceSummary
            firstParlor={firstParlor}
            secondParlor={secondParlor}
            mainColor={mainColor}
            event={event}
          />
        </Stack>

        <Stack
          padding="20px"
          className="body_16_m gray900"
          style={{ background: "white" }}
        >
          <CTypeFacility
            firstParlor={firstParlor}
            secondParlor={secondParlor}
            mainColor={mainColor}
          />
        </Stack>
      </Stack>
      <FixedBottomButton
        text={
          sidoSigungu
            ? sidoSigungu + " 지역 장례식장 상세 비용 더 알아보기"
            : "지역 장례식장 상세 비용 더 알아보기"
        }
        backgroundColor={mainColor.c300}
        href={GOI_WEB_URL + "/match/request/?utm_source=dogsound"}
        event={
          event
            ? {
                domain: event?.domain,
                path: "prlr_compare",
                trigger_and_target: "Fixed_CTA",
              }
            : undefined
        }
      />
    </>
  );
}
